import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=7688b6da&scoped=true&"
import script from "./DetailProduct.vue?vue&type=script&lang=ts&"
export * from "./DetailProduct.vue?vue&type=script&lang=ts&"
import style0 from "./DetailProduct.vue?vue&type=style&index=0&id=7688b6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688b6da",
  null
  
)

export default component.exports